export default __webpack_public_path__ + "f6ab7ca933ce20eb1d925935783d5e30.svg";